import axiosInstance from '../config/axios';

// ──────────────────────────────────────────────
// Marketplace APIs
// ──────────────────────────────────────────────

/**
 * Fetch all courses
 */
export const getCourses = () =>
  axiosInstance.get('/getCourses-web').then((res) => res.data);

/**
 * Fetch recommended courses
 */
export const getRecommended = () =>
  axiosInstance.get('/recommended-web').then((res) => res.data);

/**
 * Fetch trending courses
 */
export const getTrending = () =>
  axiosInstance.get('/trending-web').then((res) => res.data);
